import { Grid, Typography } from '@mui/material';
import { usePqrClosing } from './hook';
import { PqrClosingProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';

export const PqrClosing = (props: PqrClosingProps) => {
    const {
        formik,
        complianceTerms,
        nonComplianceReasons,
        isClose,
        compensation,
        // isQorOrQexType,
        // isSfcSendInfoOpen,
        // sfcSendInfoWillSend,
        // handleCloseSfcSendInfo,
    } = usePqrClosing(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Observación cierre
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Observación cierre"
                    name="observation"
                    size="small"
                    required
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observation}
                    errors={formik.errors.observation}
                    value={formik.values.observation}
                    onChange={formik.handleChange}
                    disabled={!props.isClousureStatus}
                />
            </Grid>
            {isClose && (
                <>
                    <Grid item xs={12}>
                        <Typography
                            style={{ fontWeight: 'bold', color: '#000' }}
                        >
                            Notificación DFC
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Checkbox
                            label="Enviar Email Cierre"
                            checked={Boolean(formik.values.emailNotification)}
                            onChange={() => {
                                formik.setFieldValue(
                                    'emailNotification',
                                    !formik.values.emailNotification
                                );
                            }}
                            isCheckMode
                            disabled={props?.isSurvey}
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                </>
            )}
            {props.isClousureStatus && (
                <>
                    <Grid item xs={12}>
                        <Typography
                            style={{ fontWeight: 'bold', color: '#000' }}
                        >
                            Muestra
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FieldText
                            label="Observaciones de auditoría"
                            name="auditObservations"
                            size="small"
                            required
                            rows={3}
                            onBlur={formik.handleBlur}
                            touched={formik.touched.auditObservations}
                            errors={formik.errors.auditObservations}
                            value={formik.values.auditObservations}
                            onChange={formik.handleChange}
                            disabled={!props.isSample}
                        />
                    </Grid>
                </>
            )}
            {/* TODO: reactivar "Enviar a la SFC" cuando se requiera en producción
            {props.isClousureStatus && isQorOrQexType && (
                <>
                    <Grid item xs={12}>
                        <Typography
                            style={{ fontWeight: 'bold', color: '#000' }}
                        >
                            Enviar a la SFC
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Checkbox
                            label="Enviar a la SFC"
                            checked={Boolean(
                                formik.values.manualSendToSfcIfAudit
                            )}
                            onChange={() => {
                                formik.setFieldValue(
                                    'manualSendToSfcIfAudit',
                                    !formik.values.manualSendToSfcIfAudit
                                );
                            }}
                            isCheckMode
                        />
                    </Grid>
                </>
            )}
            */}
            <Grid item xs={12} sm={6} md={4}>
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                        Cumplimiento de términos
                    </Typography>
                </Grid>
                <Grid item xs={12} mt={1.5}>
                    <AutocompleteField
                        data={formatParams(complianceTerms)}
                        label="Cumplimiento de términos"
                        name="complianceTerms"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.complianceTerms}
                        errors={formik.errors.complianceTerms}
                        value={formik.values.complianceTerms}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('complianceTerms', value)
                        }
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                        Motivo incumplimiento
                    </Typography>
                </Grid>
                <Grid item xs={12} mt={1.5}>
                    <AutocompleteField
                        data={formatParams(nonComplianceReasons)}
                        label="Motivo incumplimiento"
                        name="nonComplianceReason"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.nonComplianceReason}
                        errors={formik.errors.nonComplianceReason}
                        value={formik.values.nonComplianceReason}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('nonComplianceReason', value)
                        }
                    />
                </Grid>
            </Grid>
            {isClose && (
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                        Resarcimiento
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} mt={1.5}>
                            <Checkbox
                                label="Resarcimiento"
                                checked={Boolean(formik.values.compensation)}
                                onChange={() => {
                                    formik.setFieldValue(
                                        'compensation',
                                        !formik.values.compensation
                                    );
                                }}
                                onBlur={formik.handleBlur}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} mt={1.5}>
                            {formik.values.compensation && (
                                <FieldSelect
                                    data={formatParams(compensation)}
                                    label="Tipo resarcimiento"
                                    name="typeCompensation"
                                    size="small"
                                    required
                                    onBlur={formik.handleBlur}
                                    touched={formik.touched.typeCompensation}
                                    errors={formik.errors.typeCompensation}
                                    value={
                                        formik.values.typeCompensation as string
                                    }
                                    onChange={formik.handleChange}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            )}
            {/* TODO: reactivar modal "Enviar a la SFC" cuando se requiera en producción
            <Dialog
                title="Envío a la Superintendencia Financiera (SFC)"
                open={isSfcSendInfoOpen}
                onClose={handleCloseSfcSendInfo}
                maxWidth="sm"
            >
                <Typography
                    component="div"
                    variant="body1"
                    paragraph
                    sx={{ mb: 0 }}
                >
                    {sfcSendInfoWillSend ? (
                        <>
                            La opción de envío a la SFC está{' '}
                            <strong>activa</strong>.
                        </>
                    ) : (
                        <>
                            La opción de envío a la SFC está{' '}
                            <strong>inactiva</strong>; al guardar, el caso no se
                            enviará a la SFC.
                        </>
                    )}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{ mt: 2 }}
                    color="text.secondary"
                >
                    Si desea cambiar la selección marque o desmarque{' '}
                    <Box component="span" sx={{ fontWeight: 700 }}>
                        Enviar a la SFC
                    </Box>
                    .
                </Typography>
            </Dialog>
            */}
        </Grid>
    );
};
